export default "__VITE_ASSET__yaDdVsHA__"